import { httpClient } from '../http/httpClient'

export type AppConfigResponse = {
  cdnUrl: string
  content: boolean
  customers: boolean
  inviteUrl: string
  links: boolean
  name: string
  prizes: boolean
  supportEmail: string
  supportPhone: string
  supportUrl: string
  termUrl: string
  unico: boolean
  validationUrl: string
  SHOW_PIN?: boolean
  SHOW_LEADS_PAGE?: boolean
  SHOW_RADAR_PAGE?: boolean
  SHOW_MANAGER_PAGE?: boolean
  SHOW_SUPPORT_REQUESTS?: boolean
  SHOW_JOURNEY_REPORT?: boolean
  USE_BALANCE_CACHE?: boolean
  CAN_REGISTER_SELLER?: boolean
  CAN_REGISTER?: boolean
  CAN_SEND_NOTIFICATION?: boolean
}

export const getAppConfig = async () => {
  const { data } = await httpClient
    .get<AppConfigResponse>('/config/app')
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
